/* unplugin-vue-components disabled */import script from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=d7182718&lang=scss"

const __exports__ = script;

export default __exports__